"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Measurement = void 0;
const MeasurementControls_1 = require("./components/MeasurementControls");
const MeasurementService_1 = require("./MeasurementService");
class Measurement {
    constructor() {
        this.measurementFunctions = {
            distance: () => this.measurementService.measurementStart(1 /* DISTANCE */),
            height: () => this.measurementService.measurementStart(2 /* HEIGHT */),
            angle: () => this.measurementService.measurementStart(3 /* ANGLE */),
            area: () => this.measurementService.measurementStart(4 /* AREA */),
            clear: () => this.measurementService.clear()
        };
        this.parentEl = document.getElementById('measurement');
        if (!this.parentEl) {
            throw new Error("Parent element (measurement) is undefined");
        }
        this.measurementControls = new MeasurementControls_1.MeasurementControls(this.parentEl);
        this.measurementService = new MeasurementService_1.MeasurementService();
        this.addEvents();
    }
    disable() {
        this.measurementService.disable();
    }
    dispose() {
        this.removeEvents();
    }
    clear() {
        this.measurementFunctions.clear();
    }
    addEvents() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        (_b = (_a = this.measurementControls) === null || _a === void 0 ? void 0 : _a.distanceBtn) === null || _b === void 0 ? void 0 : _b.setEvent('click', this.measurementFunctions.distance);
        (_d = (_c = this.measurementControls) === null || _c === void 0 ? void 0 : _c.heightBtn) === null || _d === void 0 ? void 0 : _d.setEvent('click', this.measurementFunctions.height);
        (_f = (_e = this.measurementControls) === null || _e === void 0 ? void 0 : _e.angleBtn) === null || _f === void 0 ? void 0 : _f.setEvent('click', this.measurementFunctions.angle);
        (_h = (_g = this.measurementControls) === null || _g === void 0 ? void 0 : _g.areaBtn) === null || _h === void 0 ? void 0 : _h.setEvent('click', this.measurementFunctions.area);
        (_k = (_j = this.measurementControls) === null || _j === void 0 ? void 0 : _j.clearBtn) === null || _k === void 0 ? void 0 : _k.setEvent('click', this.measurementFunctions.clear);
    }
    removeEvents() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        (_b = (_a = this.measurementControls) === null || _a === void 0 ? void 0 : _a.distanceBtn) === null || _b === void 0 ? void 0 : _b.removeEvent('click', this.measurementFunctions.distance);
        (_d = (_c = this.measurementControls) === null || _c === void 0 ? void 0 : _c.heightBtn) === null || _d === void 0 ? void 0 : _d.removeEvent('click', this.measurementFunctions.height);
        (_f = (_e = this.measurementControls) === null || _e === void 0 ? void 0 : _e.angleBtn) === null || _f === void 0 ? void 0 : _f.removeEvent('click', this.measurementFunctions.angle);
        (_h = (_g = this.measurementControls) === null || _g === void 0 ? void 0 : _g.areaBtn) === null || _h === void 0 ? void 0 : _h.removeEvent('click', this.measurementFunctions.area);
        (_k = (_j = this.measurementControls) === null || _j === void 0 ? void 0 : _j.clearBtn) === null || _k === void 0 ? void 0 : _k.removeEvent('click', this.measurementFunctions.clear);
        this.measurementService.dispose();
    }
}
exports.Measurement = Measurement;
